import { Box, Typography } from '@mui/material'

interface ISDSummary {
  isdName: string
  totalAmount: number
}

interface Props {
  title: string
  totalAmount: number
  isdSummaries: ISDSummary[]
}

export const PriorityBudgetDisplay = (props: Props): JSX.Element => {
  return <Box sx={{ borderBottom: '1px solid var(--grey-300)', mt: '1em' }}>
    <Typography variant='h5'>
      {props.title}
    </Typography>

    <Typography variant='body1'>
      Budget requests broken down by ISDs and Districts
    </Typography>

    {props.isdSummaries.map((summary, index) => (
      <Box
        key={index}
        sx={{
          mt: '1em',
          bgcolor: 'var(--grey-100)',
          borderRadius: '16px',
          py: '10px',
          px: '24px',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant='h4'>
          {summary.isdName}
        </Typography>

        <Typography variant='body1' sx={{ textAlign: 'right', fontSize: '16px' }}>
          {summary.totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
        </Typography>
      </Box>
    ))}

    <Typography variant='h5' sx={{ textAlign: 'right', mt: '1em', mr: '24px' }}>
      Total: {props.totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
    </Typography>
  </Box>
}
